<template>
  <k-editor-form v-if="list_type && contents">
    <template #left>
      <div>
        <k-text-field textarea label="Import data" v-model="import_data"></k-text-field>
        <k-autocomplete label="Row delimiter" v-model="row_delimiter" :items="delimiters"></k-autocomplete>
      <!--
        <k-checkbox label="Headers" v-model="is_headers"></k-checkbox>
      -->

      </div>
      <div>
        <k-btn @click.stop="convert()">Read CSV</k-btn>
        <k-btn @click.stop="create_data()">Convert</k-btn>
      </div>

      <div>
        <table>
          <thead>
            <tr>
              <td v-for="(row,index) in converted_rows">
                <k-autocomplete label="Field" :items="fields" item-text="title" item-value="name" clearable v-model="row_fields[index]"></k-autocomplete>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="line in converted">
              <td v-for="row in line">
                {{row}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>


      <template v-for="editor in editors">
        <div class="elevation-4">
          <editor :data="id" ref="editors" :initial="editor" :noheight="true" :hideactions="true"></editor>
        </div>
      </template>
    </template>
    <template #right-buttons>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>

    </template>
  </k-editor-form>
</template>

<script>
import * as FormItems from '@/components/form_items'
import ContentModel from '@/models/content.js'
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue'
import Papa from 'papaparse';
import Editor from './Editor';

export default {
  props: ['id', 'data_id'],

  data () {
    return {
      channel: undefined,
      list_data: {},
      is_headers: false,
      delimiters: [{text: "tab", value: "\t"}, {text: ";", value:";"}, {text: ",", value: ","}],
      row_delimiter: "\t",
      import_data: "",
      data: [],
      converted: [],
      converted_rows: [],
      row_fields: [],
      editors: []
    }
  },
  components: {
    Editor
  },
  computed: {
    headers () {
      var ret = [{ text: 'Id', value: 'id', align: 'left' }];
      _.each(this.fields, (field) => {
        ret.push({ text: field.title, value: 'data.' + field.name, align: 'left', sortable: true});
      });
      ret.push({ text: 'Actions', value: 'actions', align: 'right', sortable: false});
      return ret;
    },
    contents () {
      return Object.values(this.list_data);
    },

    content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.id;
      });
    },
    fields () {
      var lt = this.list_type;
      return lt.fields["fields"];
    },
    list_type () {
      var cl = this.content_list;
      return _.find(this.list_types, (lt) => {
        return lt.id == cl.cms_list_type_id;
      });
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
  
  },
  mounted() {
    this.connect_ws();
  },
  beforeDestroy: function() {
    this.channel.leave();
  },
  methods: {
    convert () {
      var data = Papa.parse(this.import_data, {
        delimiter: this.row_delimiter, 
        skipEmptyLines: true, 
        header: this.is_headers
      });
      this.converted = data.data;
      this.converted_rows = this.converted[0];
    },

    create_data () {
      this.editors = _.map(this.converted, (row) => {
        var retdata = {};

        _.each(this.row_fields, (field, idx) => {
          if (typeof(field) != "undefined" && field != null) {
            retdata[field] = row[idx];
          }
        });
        return retdata;
      });


    },

    reset() {

    },
    save (close) {
      _.each(this.$refs.editors, (editor) => {
        editor.save(false);
      });
      this.$root.close_bottom_sheet();

    },
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    connect_ws () {
      var self = this;
      this.channel = this.$socket.channel("cms:list_datas:"+this.id);
      this.channel.on("init", function(msg) {
        msg.list_data.forEach(function(d) {
          Vue.set(self.list_data, d.id, d);
        });
      });
      this.channel.on("update", function(msg) {
        Vue.set(self.list_data, msg.list_data.id, msg.list_data);
      });
      this.channel.on("delete", function(msg) {
        Vue.delete(self.list_data, msg.list_data.id);
      });
      this.channel.join();
    }
  }
}
</script>
